import { Check } from '@insify/design-system/icons';
import { textSm } from '@insify/design-system/typography';
import { ContentContextWrapper } from '@objectiv/tracker-react';
import clsx from 'clsx';

import styles from './ReceiptContainer.module.css';

const ReceiptContainer = ({
  className,
  header,
  banners,
  children,
}: {
  className?: string;
  header?: React.ReactElement;
  banners?: React.ReactElement[];
  children: React.ReactNode;
}) => {
  return (
    <ContentContextWrapper id='receipt'>
      <div className={className}>
        {header && <div className={styles.header}>{header}</div>}
        <div className={styles.bodyAndBannerContainer}>
          <div className={styles.body}>{children}</div>
          {banners && (
            <div className={clsx(styles.banner, textSm)}>
              {banners.map((banner, index) => (
                <p key={index}>
                  <Check className={styles.check} />
                  {banner}
                </p>
              ))}
            </div>
          )}
        </div>
      </div>
    </ContentContextWrapper>
  );
};

export { ReceiptContainer };
